<h2 lgTranslate>.Shortcuts</h2>
<div class="shortcuts" lgArrowNavigation [horizontalNavigation]="false">
    @for (shortcut of _shortcuts(); track $index) {
        <div class="name" [class.name--disabled]="!shortcut.original.enabled()">
            <span
                [tabindex]="shortcut.original.enabled() ? 0 : -1"
                (click)="_triggerShortcut($event, shortcut)"
                (keydown.enter)="_triggerShortcut($event, shortcut)"
                >{{ shortcut.name }}
            </span>
        </div>
        <div class="key" [class.key--disabled]="!shortcut.original.enabled()">
            <span>{{ shortcut.key }}</span>
        </div>
    }
</div>
